
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`Sena se tlisoa ke
                    <a href="${0}">Folksonomy Engine project</a>. Seke oa tsilatsila
                    ho nka karolo kapa ho fana ka maikutlo`,
'h5d824b4954e56ea5': html`Scan your <span class="everyday">everyday</span> <span class="foods">foods</span>`,
'h6bdd1b427aa985a4': html`Sesebelisoa sena se u lumella ho lokisa lethathamo la metsoako. O ka eketsa, oa tlosa kapa oa hlophisa
                lenane la metsoako.
                <br>
                Sebopeho sena <span class="highlight">␣</span> se emetse sebaka.
                <br>
                Sebopeho sena <span class="highlight">↩︎</span> se emetse ho khaoha ha mola. `,
'hb28f1f2ec1744ee9': html`Lisebelisoa tsena li entsoe le ho faeloa ke basebelisi bakeng sa ts'ebeliso ea mofuta ofe kapa ofe. Ikutloe
                    u lokolohile ho kenya ea hau. Thepa le boleng boo u bo etsang
                    <strong>e tlameha ho ba 'nete</strong>. U ka qoela ho
                    <a href="${0}">lenane la thepa e seng e sebelisoa ke sechaba</a>
                    kapa u hlahlobe
                    <a href="${1}">litokomane tsa thepa le enjine ea eona ea ho batla</a>.`,
's000a5b76bd3a01c2': `E kenya thepa...`,
's000d98595e959c1e': `Get It On Google Play`,
's013bdc8cf0d3583d': `Re thuse ka metsoako`,
's01d2865e3e1d5501': `Thank you for your assistance!`,
's02ce7a2e7c1b020b': `Netefatsa lijalo`,
's03e9c8114521b998': `Ke tla lokisa metsoako`,
's05ec315d9308091a': `Letšoao la likhutlo tsa barcode`,
's061eb5af92512c85': `E bolokiloe! O ka thusa ka e 'ngoe?`,
's06847c221c4c0bc1': `Ke kopa ho theha setša ho [hlalosa ts'ebeliso ea hau]...`,
's06f6c6f99db6b552': `Ea mantlha`,
's081e2ad82db71e1d': `Maemo a Hlophisitsoeng`,
's09205907b5b56cda': `No`,
's0b4235aae602a950': `litokomane tse inehetseng`,
's0bb2d48532acc455': `Khoasolla CSV`,
's0d5b7fee0311db68': `Property`,
's0fb218abc2e157ed': `Setšoantšo se fosahetse`,
's100c4928cc74642a': `support the advancement of public health research.`,
's10db5498186c083b': `Hlakola lijalo`,
's11a18a69b30b65ed': `Re thuse ho lokisa liphoso lethathamong la metsoako`,
's1205d5f6fccf8e69': `Boleng ba Thepa`,
's15d64a0a6715285a': `Senotlolo se secha`,
's166bd56d19670a72': `Zoom`,
's19059bf0c4f7c162': `Sebaka sa khetho`,
's1a52515ec8ddade8': `Product barcode`,
's1c5031113de500ce': `keeping our database open &amp; available to all,`,
's1dc4daf989c71284': `Re thuse ho lokisa litaba tsa phepo`,
's1e00019dc454872d': `Ka kopo, fana ka lebitso la thepa u sebelisa tšobotsi ea lebitso la thepa.`,
's1e49126af0935a5b': `Lethathamo la lihlahisoa tse sebelisang thepa ena`,
's21e73088de6f26f3': `Download on the App Store`,
's255857544a9d5ec0': `Reset`,
's25e94495991e95ba': `Thanks for your help! Can you assist with another question?`,
's2ceb11be2290bb1b': `Cancel`,
's2db7b654c0a9bde0': `Ngola thepa`,
's300b3a6ee4e1252d': str`Papali e Fosahetseng ${0}%`,
's33f786bb6b4f0cf4': `Sephetho sa lijalo`,
's33f85f24c0f5f008': `Save`,
's34be4af4e8fec4ae': `Botsa sechaba pele`,
's36d86adc823cbfa6': `Pele o theha setša se secha, buisana le sechaba ka sona:`,
's3781d25aa51a736c': `Folksonomy Engine Documentation`,
's383ae4449428b61e': `Seta lijalo bocha`,
's39bcf88721a1e8ee': `Seta khetho bocha`,
's39e14e14300694c7': `Litokomane le Litataiso`,
's3b430cfa5c1fe7f4': str`Litokomane tsa ${0}`,
's3f4e4b52f230a892': `Canvas ea setšoantšo`,
's417b90913e05bc17': `Preview`,
's41f7dca46d3f1b4a': `Value`,
's422bba9636ce2489': `Setšoantšo se bohareng`,
's42dd66b2441566fd': `Letšoao la bohareng`,
's43df2e8395f6834e': str`Please give to our ${0} Fundraiser`,
's453188ea728f64da': `Add a nutrient`,
's453ab0dbb9b5c777': `Fetola boholo ka ho le letona`,
's475b08749d0706ed': `Help us inform millions of consumers around the world about what they eat`,
's49730f3d5751a433': `Loading...`,
's4bbc7472834a9686': `Your browser does not support barcode scanning.`,
's4d42cc7e00076a3b': `Palo ea Lihlahisoa`,
's4df2f533c0c1e7d0': `Litaolo tsa litšoantšo`,
's4e94adf723979402': `Open Food Facts needs your help with this product.`,
's4f4886341969d552': `Kgetho ya ho suthisa`,
's4f751fb9b3ed766c': `Ho Theha Thepa e Ncha`,
's547c12ae169d00bc': `Available on F-Droid`,
's5560fb119e40923d': `Kenya lebitso la thepa...`,
's55d7249883a98ca1': `mabapi le thepa ena ho Open Food Facts wiki`,
's565867d84c04aea2': `Sefa thepa...`,
's5666afe5cd0166de': `Ka kopo, lokisa liphoso kapa u fetole mongolo pele u netefatsa`,
's57472465a23b41db': `Values`,
's58e1eeea7a60ae51': `E kenya lihlahisoa...`,
's59df20feee978e5b': `Error: Invalid value.`,
's5c92c0051d44b6de': `Re thuse ho lokisa litaba tsa phepo.`,
's5dd6f12783fca34f': `Fetola lethathamo la metsoako`,
's5e8250fb85d64c23': `Close`,
's5ed03bb1f3a15949': `Picture`,
's6306a31415aea913': `I SUPPORT`,
's6498dfe4855bb3a7': `unit`,
's64ef2a6c2dd1d3d1': `Edit`,
's66413c24dcf680e2': `Skip`,
's67ae6594857a4d57': `Thanks for your contribution!`,
's6cee7cad81dfedd1': `Setšoantšo se Fokotsoeng`,
's6d7b6cdedaadfb6e': `Each donation counts! We appreciate your support in bringing further food transparency in the world.`,
's7124dde792a8faa2': `Android APK`,
's718dea04853f80ae': str`Papali e Ntle ${0}%`,
's71a5c9f4b68ef4d4': `Count`,
's74cb3d66f6a668e1': `Litokomane`,
's787dd11bed0dc88a': `Fetola boholo ka ho le letšehali`,
's7ce4fd9430e80cea': `value`,
's801a05fa8e881f37': `Ithute haholoanyane ka tlhahiso ea thepa le litataiso:`,
's8038273de2cf8b73': `Ka kopo, khetha sebaka seo u ka se jarang.`,
's839cc2908a5387f2': `Sefa barcode...`,
's86197dcf3e96af64': `Sheba le ho batla thepa e teng`,
's8a63be30a129a59c': `Fetola boholo bo tlase`,
's8a8bfd67f2dd2810': `Download the OFF app with this QR code`,
's8af61807443f32a4': `Actions`,
's8b33c244759d7bd4': `Fetola boholo holimo ka ho le letona`,
's8db84aa4bc949af2': `Ngola Thepa e Ncha`,
's8f839a03997a16d7': `Sheba Sehlahisoa`,
's901ae1e236ac45d3': `Hlakola ho hlakolwa`,
's907f7a97c6b29425': `Hlokomela hore mohlala oa data o ka fetoloa. Sebelisa ka kotsi ea hau.`,
's95d23d03f9147581': `Unzoom`,
's976dfd19ef58a1e1': `Click to scan a barcode and find out its details (health, preferences, etc.)`,
's98ff35f2a00dc60d': `Lisebelisoa :`,
's9a7f60fce090ecaf': `E hlolehile ho kenya thepa. Ka kopo, leka hape hamorao.`,
's9b87abd68fb9df45': `Ha ea fumanoa? Theha senotlolo se secha {value}`,
's9c0f52425fd2f07e': `Eka se Tšoanang`,
's9fc41f789c63b40d': `Products`,
'sa1fa766e0d5634d7': `Ha ho Lintlha tse Fumanehang`,
'sa548778b24054030': `Lekola thepa eohle e tlatselitsoeng ho tsoa morerong oa Folksonomy Engine. Mehaho ena e fana ka boitsebiso bo eketsehileng le lintlha tse ling mabapi le lihlahisoa tsa Open Food Facts.`,
'sa63907958bd0ec4b': `Fetola boholo holimo ka ho le letšehali`,
'sa95b4224f685a36a': `Koala modal`,
'sab56a1d439576fd6': `Letšoao la tlhahiso`,
'sac47ea2901d04c15': `Fetola boholo bo tlase ka ho le letšehali`,
'sb125227d436c2925': `Batla mohopolo oa thepa ea hau sebakeng sa polokelo ea litaba se teng:`,
'sb125568d43642e6f': `Araba lipotso mabapi le sehlahisoa.`,
'sb1c538e038f9b214': str`Papali e ntle haholo ${0}%`,
'sb28639570ff3b852': `lethathamo la thepa eohle`,
'sb3bdd638a58d30f4': `engage a community of committed citizens,`,
'sb3cbcc1bd0fff140': `Hang ha u se u netefalitse hore thepa ea hau ha e eo 'me sechaba se lumela hore e na le thuso, u lokela ho e ngola pele ho wiki.`,
'sb3d4f79d9d8b71e5': `Submit`,
'sb560fa37a7bfb6c2': `Ha ho lihlahisoa tse fumanoeng sebakeng sena.`,
'sb7f72e4c8a2d3357': `Tlhophisa boleng...`,
'sb8178320160f84ea': `Bontša lijalo`,
'sbad7d2734149470b': `Validate`,
'sbb623d6b18d966a0': `Nutrition facts are displayed on the packaging:`,
'sbd6be5cde472f37c': `Litlhaloso tsohle li arabiloe! Ke leboha thuso ea hao!`,
'sbd9a0b2293b3cd3c': `Serving size`,
'sbe472dc3c2685985': `Boleng bo Tšoanang`,
'sc0520e1732a5c568': `Expand image`,
'sc0cc559e7ede852a': `Resize top`,
'sc1c08d0cbcc3bd24': `Ha e Tšoanang`,
'sc52696641af72b53': `Install the app!`,
'sc5575e3107f87874': `Rotate image to the left`,
'sc57b630a7a70c61f': `Tokiso e sisintsweng`,
'sc681b137e8f604f7': `Confirm deletion`,
'sc6daf8a31883f8b9': `Suthisa setšoantšo`,
'sc895972c88d38ca5': `Thepa ea Folksonomy`,
'sca0c3305aff570b8': str`per specified serving "${0}"`,
'scace072bef961918': `Mela`,
'scb3b0671d7b7f640': `Boleng bo bocha`,
'scb489a1a173ac3f0': `Yes`,
'scbab4bd737ba7934': str`group photo donation ${0}`,
'scd21019c3cd618f3': `Kopana le Puisano ea Slack`,
'scdb6cad0b92721bf': `Ha ho thepa e fumanoeng.`,
'scf23a05631f93732': `Netefatsa Hlakola`,
'scfed2f270ef6a3aa': `Khetha sebaka`,
'sd1022bc1ef9204f7': `Setšoantšo se ka atametsang`,
'sd1077c055cf9ba6b': `Re thuse ho netefatsa lenane la metsoako ea sehlahisoa.`,
'sd698d21ddecba56b': `Lumela! U ka re thusa ho ntlafatsa lintlha tsa sehlahisoa ka ho araba likarolo tse latelang:`,
'sd82bc2decefa621b': `remain independent of the food industry,`,
'sdb97e5976482606e': `Hlahloba hore na thepa e se e ntse e le teng`,
'sdbf806fefc584115': `U lokela ho fumana a`,
'sdc673e73b5c13aea': `Delete`,
'sdc792b75f1edcaba': `Re thuse ho lokisa mopeleto oa metsoako.`,
'sdca5deead576ceee': `Fetola boholo bo tlase ka ho le letona`,
'sdcc2555c5dde524f': `Na ehlile u batla ho hlakola ntho ee? Ketso ena e ke ke ea etsolloa.`,
'se206feec7ec57b28': `per 100g`,
'se419a9ab36987490': `Ha e sebetse`,
'se5127cf0f92e7e48': `Keletso: o ka fumana hape`,
'se773f50d2a16d481': `Rotate image to the right`,
'sebb2c6c830a44574': `technical infrastructure (website/mobile app) &amp; a small permanent team`,
'sec6377f3c4e9b28c': `Ke tla sisinya sejalo se betere`,
'seea3800e27baa686': `Lihlahisoa ka bomong`,
'sefaba4adc4ec9219': `Lintho tsa Folksonomy`,
'seffa8ca49175b5f0': `Thepa ea motho ka mong`,
'sf44a6b3b232c28ea': str`Tlosa boleng ba hajoale ka ${0}`,
'sf4cd86a2f5ef2588': `Sehlahisoa Barcode`,
'sf57a61152168cc81': `Re thuse ho lokisa phumano ea motsoako`,
'sf88b90b8ba23871c': `Papali e sa Tsejoeng`,
'sf9aee319a006c9b4': `Add`,
'sfacbbe968fa7d773': `Lebitso la thepa:`,
'sfc40ea3d5d5aa6f8': `Your donations fund the day-to-day operations of our non-profit association:`,
'sfe87465d50530725': `Boleng bo tsamaellanang`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  